import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button
} from '@mui/material';
import { useLanguage } from './LanguageContext';

const LogoutConfirmation = ({ open, onConfirm, onCancel }) => {
    const { t } = useLanguage();

    return (
        <Dialog open={open} onClose={onCancel} aria-labelledby="logout-dialog-title">
            <DialogTitle id="logout-dialog-title">{t.logout}</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    {t.confirmLogout}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} variant="outlined" color="primary">
                    {t.cancel}
                </Button>
                <Button onClick={onConfirm} variant="contained" color="error">
                    {t.logout}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LogoutConfirmation;